import { request } from '../../../../global/services/request'

export async function getAccountCertificates(accountId: string) {
  return await request({
    path: `/accounts/${accountId}/account/certificates?limit=100&page=1`,    
    method: 'GET'
  })
}

export async function getAvailableCertificates(accountId: string) {
  return await request({
    path: `/accounts/${accountId}/certificateblueprints?limit=100&page=1`,    
    method: 'GET'
  })
}

export async function addAccountCertificate(accountId: string, blueprintId: string, label: string) {
  return await request({
    path: `/accounts/${accountId}/account/certificates`,
    method: 'POST',
    body: {
      certificate_blueprint_id: blueprintId,
      label
    }
  })
}

export async function removeAccountCertificate(accountId: string, certificateId: string) {
  await request({
    path: `/accounts/${accountId}/account/certificates/${certificateId}`,
    method: 'DELETE'
  })
}

